import React from 'react';
import { useLocation } from 'react-router';

export interface PublicRouteProps {
    children: React.ReactNode;
}

export const PublicRoute = ({ children }: PublicRouteProps): React.ReactNode => {
    const location = useLocation();
    const { pathname } = location;
    // Guarded for SSR: there is no document during a server render, and the cookie is a
    // client-side breadcrumb for the login return path, so skipping it costs nothing.
    if (typeof document !== 'undefined' && pathname !== '/login') {
        document.cookie = `cpage=${pathname}; SameSite=lax; path=/`;
    }
    return children;
};
